import React from "react";
import PropTypes from "prop-types";

import Dropdown from "components/Dropdown";
import ScreenWidth from "components/hoc/ScreenWidth";
import Translate from "utils/translate";

import Stage from "./Stage";

import styles from "./StageProgress.css";

const { t } = new Translate("StageProgress");

const StageProgress = ({ availableStages, isMobile, onSwitch, selectedStage, translationKey }) => {
  const selectedIndex = availableStages.indexOf(selectedStage);

  function handleSelect(stage) {
    if (selectedStage !== stage) {
      onSwitch(stage);
    }
  }

  const stages = availableStages.map((stage, idx) => (
    <Stage
      isPassed={selectedIndex >= idx}
      key={idx}
      label={t(`${translationKey}.${stage}`)}
      onClick={() => handleSelect(availableStages[idx])}
    />
  ));

  const Input = ({ value }) => <Stage label={t(`${translationKey}.${value}`)} isPassed />;

  const stageDropdown = (
    <Dropdown
      header={t("selectStage")}
      inputComponent={Input}
      inputValueExtractor={(v) => v}
      onChange={handleSelect}
      selectedValues={selectedStage ? [selectedStage] : []}
      valueExtractor={(stage) => ({ label: t(`${translationKey}.${stage}`) })}
      values={availableStages}
    />
  );

  return <div className={styles.stageProgress}>{isMobile ? stageDropdown : stages}</div>;
};

StageProgress.propTypes = {
  availableStages: PropTypes.arrayOf(PropTypes.string).isRequired,
  isMobile: PropTypes.bool,
  onSwitch: PropTypes.func,
  selectedStage: PropTypes.string,
  translationKey: PropTypes.string,
};

StageProgress.defaultProps = {
  translationKey: "dealStages",
};

export default ScreenWidth(StageProgress);
